export default __webpack_public_path__ + "static/media/instagram.0bd393ca.svg";